<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_GRAPHIC_DESIGNERS"
    title="Graphic Designers"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Graphic Designers"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunityGraphicDesignerExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
      :show-filters="false"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No graphic designers found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no graphic designers available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_GRAPHIC_DESIGNERS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  useOrgCommunityGraphicDesignerExpertiseFeedStore,
} from "SmartFeed/stores/feed/org-community-graphic-designer-expertise-feed-store";

export default {
  name: "GraphicDesigners",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_GRAPHIC_DESIGNERS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunityGraphicDesignerExpertiseFeedStore },
};
</script>
